import React, { Component } from 'react';

class AthleticTrainer extends Component {
  render() {
    return (
      <div className="at-notice">
        <h2>HEALTHCARE PROFESSIONALS</h2>
        <p>If you are a Healthcare Professional, please download the Go4 app from the App Store or Google Play to set up your account and find work.</p>
        <a className="badge apple" href="https://itunes.apple.com/st/app/go4ellis/id1186370661">
          <img src={require('./app-store-badge.svg')} alt="Download on the App Store" />
        </a>
        <a className="badge google" href="https://play.google.com/store/apps/details?id=com.go4ellis">
          <img src={require('./google-play-badge.png')} alt="Get it on Google Play" />
        </a>
      </div>
    )
  }
}

export default AthleticTrainer;